import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=73334ce4&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73334ce4')) {
      api.createRecord('73334ce4', component.options)
    } else {
      api.reload('73334ce4', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=73334ce4&", function () {
      api.rerender('73334ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JThRCuEB0fcF/JS/cancellationPolicy.vue"
export default component.exports